import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome'
import styled from '@xstyled/styled-components'
import { system } from '@trybeapp/ui.system'

export const FontAwesomeIcon = styled(FAIcon)`
  ${system}
`
